import { intl } from '@fullstory/intl';
import { defineMessage } from 'react-intl';

export const accessErrorMessage = intl.formatMessage({
  defaultMessage: 'There was a permissions check error. Please reload.',
  id: '+cmVwr',
});

export const accessErrorMessageLong = intl.formatMessage({
  defaultMessage:
    'An error occured fetching the permissions for this page. Reloading the page should fix the issue.',
  id: 'ZVxefM',
});

export const noPermissionMessage = defineMessage({
  defaultMessage: 'Your account does not have the necessary permission to perform this action.',
  id: 'ldxSVD',
});

export const standardUserRestrictedActionMessage = intl.formatMessage({
  defaultMessage: 'This action is available for admin and architect user roles.',
  id: 'eKkA4z',
});

export const styledAccessDeniedMessage = defineMessage({
  defaultMessage:
    'Only an admin, architect, or owner can take that action. {suggestion, select, none {} other {However, you can use {suggestion, select, save_as {<action>Save As</action>} duplicate {<action>Duplicate</action>} other {<action>Save As</action> or <action>Duplicate</action>}} to make a copy for yourself.}}',
  id: 'cuvRRC',
});

export const styledCannedAccessDeniedMessage = defineMessage({
  defaultMessage:
    "This isn't editable. {suggestion, select, none {} other {However, you can use {suggestion, select, save_as {<action>Save As</action>} duplicate {<action>Duplicate</action>} other {<action>Save As</action> or <action>Duplicate</action>}} to make a copy for yourself.}}",
  id: '2XbnMO',
});

export const redirectMessage = defineMessage({
  defaultMessage: 'You do not have the required permission to access that page.',
  id: 'njrML5',
});

export const accessPageError = defineMessage({
  defaultMessage: 'You do not have the required permission to access this page.',
  id: '3OYESN',
});

const accessDeniedMessage = defineMessage({
  defaultMessage:
    'Only an admin, architect, or owner can take that action. {suggestion, select, none {} other {However, you can use {suggestion, select, save_as {Save As} duplicate {Duplicate} other {Save As or Duplicate}} to make a copy for yourself.}}',
  id: 'TVdWqd',
});

const cannedAccessDeniedMessage = defineMessage({
  defaultMessage:
    "This isn't editable. {suggestion, select, none {} other {However, you can use {suggestion, select, save_as {Save As} duplicate {Duplicate} other {Save As or Duplicate}} to make a copy for yourself.}}",
  id: 'dY1MfU',
});

export const getAccessDeniedMessageString = (
  suggestion: AccessDeniedMessageSuggestionType,
  isCanned: boolean = false,
) =>
  intl.formatMessage(isCanned ? cannedAccessDeniedMessage : accessDeniedMessage, {
    suggestion,
  });

export type AccessDeniedMessageSuggestionType =
  | 'none'
  | 'save_as'
  | 'duplicate'
  | 'save_as_or_duplicate';
